<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">忘记密码</h1>
    </nav>
    <div class="content">
      <div class="list-block">
        <ul>
          <li>
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-name"></i></div>
              <div class="item-inner">
                <div class="item-title label">手机或邮箱</div>
                <div class="item-input" @click="autofocus('account')">
                  <input type="text" id="account" v-model.trim="account" placeholder="帐号">
                </div>
              </div>
            </div>
          </li>
          <li v-show="type === 'phone'">
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-password"></i></div>
              <div class="item-inner">
                <div class="item-title label">验证码</div>
                <div class="item-input">
                  <input style="width:6rem;display: inline;" @click="autofocus('veriCode')" id="veriCode" type="text" v-model.trim="veriCode" placeholder="验证码">
                  <div style="display: inline;width: 2.5rem">
                    <a @click="sendVeriCode" id="btn">发送</a>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li v-show="type === 'phone'">
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-password"></i></div>
              <div class="item-inner">
                <div class="item-title label">新密码</div>
                <div class="item-input" @click="autofocus('newPassword')">
                  <input style="width:6rem;display: inline;" id="newPassword" type="password" v-model.trim="newPassword" placeholder="新密码">
                </div>
              </div>
            </div>
          </li>
          <li v-show="type === 'phone'">
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-password"></i></div>
              <div class="item-inner">
                <div class="item-title label">确认密码</div>
                <div class="item-input" @click="autofocus('confirmPassword')">
                  <input style="width:6rem;display: inline;" id="confirmPassword" type="password" v-model.trim="confirmPassword" placeholder="确认密码">
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row">
          <div v-if="type === 'phone'" class="col-100"><a @click="submit" class="button button-big button-fill button-success">确认</a></div>
          <div v-if="type === 'email'" class="col-100"><a @click="sendEmail" class="button button-big button-fill button-success">发送邮件</a></div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import $ from 'jquery'
  import md5 from 'js-md5'

  export default {
    mounted () {
    },
    created () {
    },
    data () {
      return {
        account: '',
        type: 'phone',
        veriCode: '',
        coolDown: false,
        newPassword: '',
        confirmPassword: ''
      }
    },
    watch: {
      'account': function (val) {
        var _this = this
        if (val.indexOf('@') !== -1) {
          _this.type = 'email'
        } else {
          _this.type = 'phone'
        }
      }
    },
    methods: {
      sendVeriCode () {
        let _this = this
        if (!_this.coolDown) {
          $.showPreloader('请稍候')
          _this.gcapi('gcwwwifc/requestResetPassword', {'LoginId': _this.account})
            .then((response) => {
              $.hidePreloader()
              _this.coolDown = true
              time(document.getElementById('btn'))
              $.toast(response.body['message'])
            }, (response) => {
              $.toast(response.body['message'])
            })
        }
        let wait = 60
        function time (o) {
          if (wait === 0) {
            _this.coolDown = false
            o.innerHTML = '发送'
            o.style.color = ''
            wait = 60
          } else {
            o.innerHTML = wait + 's'
            o.style.color = '#C8C8C8'
            wait--
            setTimeout(function () {
              time(o)
            }, 1000)
          }
        }
      },
      sendEmail () {
        let _this = this
        _this.gcapi('gcwwwifc/requestResetPassword', {'LoginId': _this.account})
          .then((response) => {
            if (response.body.code === 0) {
              $.toast(response.body.message)
              _this.$router.push('/me/login')
            } else {
              $.toast(response.body.message)
            }
          }, (response) => {
            $.toast(response.body.message)
          })
      },
      submit () {
        let _this = this
        if (_this.newPassword !== _this.confirmPassword) {
          return $.toast('两次输入的密码不一致')
        }
        _this.gcapi('gcwwwifc/submitResetPassword', {'LoginId': _this.account, 'NewPassword': md5(_this.newPassword).toUpperCase(), 'VerifyCode': _this.veriCode})
          .then((response) => {
            if (response.body.code === 0) {
              $.toast(response.body['message'])
              _this.$router.push('/login')
            } else {
              $.toast(response.body['message'])
            }
          }, (response) => {
            $.toast(response.body['message'])
          })
      },
      autofocus (id) {
        $('#' + id).focus()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ForgetPassword.vue?a696d8e2